export enum ResetPasswordFormFields {
    PASSWORD = "password",
}

export type ResetPasswordFormData = Record<ResetPasswordFormFields, string>;

export interface ResetPasswordFormProps {
    token: string;
}
